import React, { useEffect, useState } from "react";
import { meta_details, metaReview } from "../../../api/services";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";

function Dashboard() {
  let { refresh } = useSelector((state) => state.general);
  let [count, setCount] = useState({
    total : 0,
    approved : 0,
    under_review : 0,
    rejected : 0,
  });

  useEffect(() => {
    fetchMeta();
  }, [refresh]);

  async function fetchMeta(params) {
    try {
      let res = await metaReview();
      
      if (res.status !== 200) toast.error("Something went wrong !!!");
      else {
        let { total, approved, under_review, rejected } = res?.data?.metaCount;
        setCount({
          total : total || 0,
          approved : approved || 0,
          under_review : under_review || 0,
          rejected : rejected || 0
        });
      }
    } catch (error) {
      toast.error("Something went wrong !!!");
    }
  }
  return (
    <div className="flex justify-between gap-3">
      {data.map((row) => (
        <div className="w-[300px] min-w-[150px] flex-wrap max-w-[300px] h-[150px] gap-2 p-3 flex flex-col justify-center items-center text-white font-semibold rounded-md bg-primary">
          {row.icon}
          <span className="text-3xl">{count[row.state] || 0} </span>
          <span className="text-lg">{row.label}</span>
        </div>
      ))}
    </div>
  );
}

let data = [
  {
    label: "Total Reviews",
    state: "total",
    icon: (
      <svg
      width={25}
      height={25}
      fill="white"
      xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>message-draw</title><path d="M18,14H10.5L12.5,12H18M6,14V11.5L12.88,4.64C13.07,4.45 13.39,4.45 13.59,4.64L15.35,6.41C15.55,6.61 15.55,6.92 15.35,7.12L8.47,14M20,2H4A2,2 0 0,0 2,4V22L6,18H20A2,2 0 0,0 22,16V4C22,2.89 21.1,2 20,2Z" /></svg>
    ),
  },
  {
    label: "Approved Reviews",
    state: "approved",
    icon: (
      <svg
      width={25}
      height={25}
      fill="white"

      xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>hand-okay</title><path d="M13.3,19.26L18.96,13.61L21.08,15.73L15.42,21.38L13.3,19.26M16.5,11.13L13.4,8.05C13.27,7.92 13.13,7.83 13,7.76L11.88,3.47C11.74,2.93 11.2,2.61 10.66,2.75C10.13,2.88 9.81,3.43 9.94,3.96L11,8.03V8.03L8.67,3.19C8.44,2.69 7.84,2.5 7.34,2.71C6.84,2.95 6.63,3.55 6.87,4.05L8.56,7.59L5.19,4.25C4.8,3.86 4.16,3.86 3.77,4.25C3.38,4.65 3.39,5.28 3.78,5.67L7.5,9.37L6.8,9.64L5.72,10.07L3.81,11.39C3.81,11.39 3,12.44 2.93,12.89C2.85,13.34 3.72,15.6 3.72,15.6H3.73C3.89,15.94 4.23,16.18 4.63,16.18A1,1 0 0,0 5.63,15.18C5.63,15.08 5.6,15 5.57,14.91L5.59,14.9L5,13.17L6.23,12.19C6.7,12.21 7.71,12.29 8.2,12.32C10.93,14.77 8.35,15.73 8.35,15.73L4.89,16.79L4.72,16.93C4.5,17.13 4.41,17.4 4.42,17.68L4.44,18.75L10.87,18.25C11.25,18.26 11.61,18.12 11.89,17.85L16.5,13.25C17.03,12.71 17.05,11.7 16.5,11.13Z" /></svg>
          ),
  },
  {
    label: "Rejected Reviews",
    state: "rejected",
    icon: (
      <svg
      width={25}
      height={25}
      fill="white"
      xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>playlist-remove</title><path d="M14 10H3V12H14V10M14 6H3V8H14V6M3 16H10V14H3V16M14.4 22L17 19.4L19.6 22L21 20.6L18.4 18L21 15.4L19.6 14L17 16.6L14.4 14L13 15.4L15.6 18L13 20.6L14.4 22Z" /></svg>
    ),
  },
  {
    label: "Under Review",
    state: "under_review",
    icon: (
      <svg
      width={20}
      height={20}
      fill="white"
      xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>reload</title><path d="M2 12C2 16.97 6.03 21 11 21C13.39 21 15.68 20.06 17.4 18.4L15.9 16.9C14.63 18.25 12.86 19 11 19C4.76 19 1.64 11.46 6.05 7.05C10.46 2.64 18 5.77 18 12H15L19 16H19.1L23 12H20C20 7.03 15.97 3 11 3C6.03 3 2 7.03 2 12Z" /></svg>
    ),
  },
];
export default Dashboard;
